<script>
import KSelect from "../../../theme/molecules/KSelect.vue";
import LanguageSelect from "../../../theme/atoms/LanguageSelect.vue";

export default {
    name: "AuthLayout",
    components: {
        LanguageSelect,
        KSelect
    },
    data() {
        return {
            selectedLocale: null,
        }
    },
    watch: {
        selectedLocale(value, oldValue) {
            if (oldValue !== null) {
                window.location.href = `?_locale=${value}`;
            }
        }
    },
    methods: {
        setAppLanguage(value) {
            this.selectedLocale = value.code;
        }
    }
}
</script>

<template>
    <div class="auth-background-gradient">
        <div class="container max-w-1100">
            <slot></slot>
            <div class="d-flex gap-4 w-100 justify-content-end my-3">
                <language-select @change="setAppLanguage"/>
            </div>
        </div>

    </div>
</template>

<style scoped>
@media (min-width: 769px) {
    .auth-background-gradient {
        background: linear-gradient(180deg, #ffffff 0%, #E9EEFB 100%);
    }
}
.auth-background-gradient{
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.max-w-1100 {
    max-width: 1050px;
}

</style>
